export default __webpack_public_path__ + "cdbded8f050b8fa73352203a74d4117e.png";